import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.jpg'
import { checkDeviceIOS } from '../../utils'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'zap';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    const encodedPassword = encodeURIComponent(password);
    api.userPassLogin(
      {
        username,
        password: encodedPassword,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-zap-container" ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Row className="login-zap-header">
            <Col>
              <img src={logo} alt="logo" className="logo-zap rounded mx-auto d-block" />
              <h1>Ingresa a tu cuenta</h1>
            </Col>
          </Row>
          <Row className="login-zap-body">
            <Col>
              <div className="zap-container-input">
                <label>CORREO ELECTRÓNICO</label>
                <Input
                  className="user-input-zap"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                />
              </div>
              <div className="zap-container-input">
                <label>CONTRASEÑA</label>
                <Input
                  className="pass-input-zap"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
              {!onLogin ? (
                <div className="container-button-zap">
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-zap"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                </div>
              ) : (
                <div className="container-progress-bar-zap" style={{ marginTop: 20 }}>
                  <Progress animated color="danger" value={100} className="zap-progress-bar" />
                </div>
              )}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <div className="recover-password-zap">
                <a href="https://app.zappingtv.com/login">Ayuda, olvidé mi contraseña</a>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              <div className="register-account-zap">
                {
                  checkDeviceIOS() ? '' : <p>¿No tienes cuenta? <a href="https://app.zappingtv.com/login" target="_blank" rel="noopener noreferrer">Suscríbete ahora</a></p>
                }
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
